const Header = ({ onScreenUpdate }) => {
  const onHealthcare = () => {
    onScreenUpdate('healthcare')
  }
  const onEnvironment = () => {
    onScreenUpdate('environment')
  }
  const onExercise = () => {
    onScreenUpdate('exercise')
  }

  const onLogo = () => {
    onScreenUpdate('welcome')
  }

  return (
    <div className="headerArea">
      <button onClick={onLogo}>
        <div className="headerLogoRow">
          <div className="horseshoeBox">
            <img
              className="logo"
              src="images/horseshoe.png"
              alt="Equine Science 4 Kids Horseshoe Logo"
            />
          </div>
          <div className="bannerLogoBox">
            <img
              className="logo"
              src="images/ES4KBanner-800px.png"
              alt="Multi-colored Equine Science 4 Kids! title on a red banner"
            />
          </div>
          <div className="horseshoeBox">
            <img
              className="flippedLogo"
              src="images/horseshoe.png"
              alt="Equine Science 4 Kids Horseshoe Logo"
            />
          </div>
        </div>
      </button>

      <div className="headersNavRow">
        <button onClick={onHealthcare} className="navHeader healthcareHeader">
          Healthcare &amp; Nutrition
        </button>
        <button onClick={onEnvironment} className="navHeader environmentHeader">
          Horses &amp; the Environment
        </button>
        <button onClick={onExercise} className="navHeader exerciseHeader">
          Exercise Physiology
        </button>
      </div>
      {/* </div> */}
    </div>
  )
}

export default Header
